/* Because IE is SAD and won't allow CSS vars :( */

export const BG_LIGHTER = '#FFFFFF';
export const BG_PRIMARY = '#FFFFFF';
export const BG_DARKER = '#DEE8E8';

export const TEXT_PRIMARY = '#37352B';

export const GREY_DARKEST = "#121212";
export const GREY_DARK = "#444444";
export const GREY_MEDIUM_DARK = "#686868";
export const GREY_MEDIUM = "#919191";
export const GREY_MEDIUM_LIGHT= "#dedede";
export const GREY_LIGHT = "#F0F0F0";
export const GREY_LIGHTEST = "#F8F8F8";

export const PRIMARY = "#b32f89";
// export const PRIMARY = "#004a97";
export const PRIMARY_DARK = "#177A80";
export const PRIMARY_DARKEST = "#00366A";
export const SECONDARY = "#062D45";
// export const SECONDARY = '#ffc107'
export const HIGHLIGHT = "#FFC20A";
export const ERROR = "#c51414";

export const SHADOW_MEDIUM = "0 4px 8px rgba(0,0,0,.10)";
export const SHADOW_LIGHT = "0 2px 2px rgba(0,0,0,.06)";
export const SHADOW_CRISP = "0 2px 4px rgba(0,0,0,.12)";
export const SHADOW_TINY = "0 1px 2px rgba(0,0,0,.10)";
export const SHADOW_DARK= "0 4px 8px rgba(0,0,0,.2)";
export const SHADOW_MENU= "-3px 0px 8px rgba(0,0,0,.2)";
export const SHADOW_NONE= "0px 0px 0px rgba(0,0,0,0)";

export const RADIUS = "6px";

export const MAIN_CONTENT_WIDTH = 900;
export const MAX_DESKTOP_WIDTH = MAIN_CONTENT_WIDTH + 200;